<template>
  <v-layout column>
    <v-form ref="form">
      <v-textarea
        v-model="comment"
        label="Novo Comentário"
      />
    </v-form>
    <p
      :class="`caption text-xs-right ${isCommentLengthOk ? 'grey--text' : 'red--text text--darken-2'}`"
    >
      {{ customCounter }}
    </p>

    <v-layout class="mb-4" justify-center>
      <v-btn flat @click="$emit('hideNewComment')">Cancelar</v-btn>
      <v-btn
        class="white--text"
        color="blue"
        :disabled="!isCommentLengthOk"
        @click="saveComment"
      >
        Confirmar
      </v-btn>
    </v-layout>

    <div class="px-3">
      <v-divider />
    </div>
  </v-layout>
</template>

<script>
import foldersService from '@/services/FoldersService';

export default {
  name: 'NewComment',
  props: {
    doc: {
      default: () => {},
      type: Object,
    },
  },
  data() {
    return {
      comment: '',
    };
  },
  computed: {
    customCounter() {
      return `${this.comment.length} de 280 caracteres`;
    },
    isCommentLengthOk() {
      return this.comment.length <= 280;
    },
    folder() {
      return this.$store.getters.activeFolder;
    },
  },
  methods: {
    saveComment() {
      const body = {
        comment: { content: this.comment },
        document_id: this.doc.id,
      };

      this.sendCommentRequest(body);
    },
    sendCommentRequest(body) {
      foldersService.sendComment(body)
        .then(() => {
          this.$store.dispatch('getActiveFolder', { id: this.folder.id, loading: false })
          .finally(() => {
            this.$refs.form.reset();
            this.$emit('hideNewComment');
          });
        })
        .catch((err) => {
          this.onSendCommentError(err);
        });
    },
    onSendCommentError(err) {
      this.$store.dispatch('toggleSnackbar', {
        show: true,
        color: 'error',
        message: err.message,
        messageIcon: 'mdi-alert-outline',
      });
    },
  },
};
</script>

<style>
  .v-messages__message {
    text-align: right;
  }
</style>



// WEBPACK FOOTER //
// src/components/document/show/NewComment.vue